// utils/timelineHelpers.ts
import type { TimelineConfig } from '../../types/timeline';

export const sortTimelineConfig = (config: TimelineConfig): TimelineConfig => ({
  decades: [...config.decades]
    .sort((a, b) => b.decade - a.decade)
    .map((decade) => ({
      ...decade,
      dates: [...decade.dates].sort((a, b) => Date.parse(b.date) - Date.parse(a.date)),
    })),
});

export const getYear = (date: string): string => new Date(date).getFullYear().toString();
